module.exports = __webpack_public_path__ + "static/media/silicone-250x210.c832897c.png";